import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { IImbpCancellationReason } from "./imbpCancellationReason"

export interface IImbpCancellationReasonRaw {
  reason: string
  reasonLabel: string
  description: string
  initiator: string
  initiatorLabel: string
}

export const ImbpCancellationReasonParser: IParser<
  IImbpCancellationReason,
  IImbpCancellationReasonRaw
> = {
  toDomain: (data: IImbpCancellationReasonRaw): IImbpCancellationReason => {
    try {
      return {
        reason: data.reason,
        reasonLabel: data.reasonLabel,
        description: data.description,
        initiator: data.initiator,
        initiatorLabel: data.initiatorLabel,
      }
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
